module.exports = __webpack_public_path__ + "static/media/tennis.2ccece07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-backgrounds/tennis.jpg
// module id = 696
// module chunks = 0